import { Component, OnInit } from "@angular/core";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { TarefasRecuperacaoCreditoService } from './tarefas-recuperacao-de-credito.service';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from "src/app/model/estado.model";
import { ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ViewChild, TemplateRef } from '@angular/core';


@Component({
    selector: 'app-tarefas-recuperacao-de-credito',
    templateUrl: './tarefas-recuperacao-de-credito.component.html',
    styleUrls: ['./tarefas-recuperacao-de-credito.component.scss'],
    standalone: false
})
export class TarefasRecuperacaoCreditoComponent implements OnInit {

  public idOperacaoCredito1: number;
  public idOperacaoCredito2: number;
  public dataRecuperacao1: Date;
  public dataRecuperacao2: Date;
  public data = new Date();
  public valorRecuperacao: number;
  public idOperacao: number;
  public estados: Estado[] = [];
  public idEstado: string;
  public idRecuperacao1: number;
  public idRecuperacao2: number;
  public idRecuperacao3: number;
  @ViewChild('meuid') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;


  constructor(
    private modalService: BnModalMessageService,
    private recuperacaoCreditoService: TarefasRecuperacaoCreditoService,
    private alertService: BnAlertsService,
    private messageService: MessageChannelService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private loadingService: BnLoadingService) {

    this.estados = this.activatedRoute.snapshot.data['dominios'].estadosRecuperacaoCredito;

  }


  ngOnInit(): void {

  }

  public criaRecuperacaoCredito() {
    if (this.idOperacaoCredito1 == null || this.dataRecuperacao1 == null || this.valorRecuperacao == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para criar');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.criarRecuperacaoCredito(this.idOperacaoCredito1, this.datePipe.transform(this.dataRecuperacao1, 'yyyy-MM-dd'), this.valorRecuperacao)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Recuperação de crédito criada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }


  public alteraEstadoRecuperacaoCredito() {
    if (this.idRecuperacao1 == null || this.idEstado == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para alterar');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.alterarEstadoRecuperacaoCredito(this.idRecuperacao1, this.idEstado)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Estado da recuperação de crédito alterado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public removeRecuperacaoCredito() {
    if (this.idRecuperacao2 == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Recuperação para remover');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.removerRecuperacaoCredito(this.idRecuperacao2)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Recuperação de crédito removida com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public removeTodasAsRecuperacoesCredito() {
    if (this.idOperacao == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Operação para remover');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.removerTodasAsRecuperacoesCredito(this.idOperacao)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Todas recuperações de crédito removidas com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public processaRecuperacaoCredito() {
    if (this.idRecuperacao3 == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Recuperacao para processar');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.processarRecuperacaoCredito(this.idRecuperacao3)
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Recuperação de crédito processada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public simulaRecuperacaoCredito() {
    if (this.idOperacaoCredito2 == null || this.dataRecuperacao2 == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para simular');
    } else {
      this.loadingService.bloqueiaTela();
      this.recuperacaoCreditoService.simularRecuperacaoCredito(this.idOperacaoCredito2, this.datePipe.transform(this.dataRecuperacao2, 'yyyy-MM-dd'))
        .subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Recuperação de crédito simulada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => { this.loadingService.liberaTela(); })
    }
  }

  public limparCriaRecuperacaoCredito() {
    this.idOperacaoCredito1 = null;
    this.dataRecuperacao1 = null;
    this.valorRecuperacao = null;
  }
  public limparAlteraEstadoRecuperacaoCredito() {
    this.idRecuperacao1 = null;
    this.idEstado = null;
  }
  public limparRemoveRecuperacaoCredito() {
    this.idRecuperacao2 = null;
  }
  public limparRemoveTodasAsRecuperacoesCredito() {
    this.idOperacao = null;
  }
  public limparProcessaRecuperacaoCredito() {
    this.idRecuperacao3 = null;
  }
  public limparSimulaRecuperacaoCredito() {
    this.idOperacaoCredito2 = null;
    this.dataRecuperacao2 = null;
  }

  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
        this.modalService.abrir('Confirmar remoção', msg, tamanho, this.msgPersonalizada, this.botoesPersonalizados)
}
  }

close() {
    this.modalService.close();
}

dismiss() {
    this.modalService.dismiss();
}
;

}
